import React, { useState, useEffect, useRef } from "react";
import testimonial1 from "../assets/testimonial/testimonial1.svg";
import testimonial2 from "../assets/testimonial/testimonial2.svg";
import testimonial3 from "../assets/testimonial/testimonial3.png";
import testimonial4 from "../assets/testimonial/testimonial4.svg";
import testimonial5 from "../assets/testimonial/testimonial5.png";
import testimonial6 from "../assets/testimonial/testimonial6.png";
import testimonial7 from "../assets/testimonial/testimonial7.png";
import testimonial8 from "../assets/testimonial/testimonial8.png";
import testimonial9 from "../assets/testimonial/testimonial9.png";
import testimonial10 from "../assets/testimonial/testimonial10.png";

interface TestimonialImage {
  id: number;
  src: string;
  alt: string;
}

const testimonialImages: TestimonialImage[] = [
  {
    id: 1,
    src: testimonial1,
    alt: "Carol Seah testimonial",
  },
  {
    id: 2,
    src: testimonial2,
    alt: "Simon Lim testimonial",
  },
  {
    id: 3,
    src: testimonial3,
    alt: "Soumya Rajan testimonial",
  },
  {
    id: 4,
    src: testimonial4,
    alt: "Nilesh Shah testimonial",
  },
  {
    id: 5,
    src: testimonial8,
    alt: "Judy Lim testimonial",
  },
  {
    id: 6,
    src: testimonial6,
    alt: "Hooi Hien Kohn testimonial",
  },
  {
    id: 7,
    src: testimonial7,
    alt: "Saurav Sen testimonial",
  },
  {
    id: 8,
    src: testimonial9,
    alt: "Aman testimonial",
  },
  {
    id: 9,
    src: testimonial10,
    alt: "Aman testimonial",
  }
];

interface Testimonial {
  id: number;
  title: string;
  text: string;
  name: string;
  role: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    title: "Driving Growth with Smart Automation",
    text:
      "Leveraging Valuefy's Wealth in a Box Technology has positioned us for growth alongside the next generation of advisors. By eliminating the complexities of manual processes, we've achieved operational efficiency and enhanced accuracy.",
    name: "Carol Seah",
    role: "CEO & Founder, WYNNES Financial Advisers",
  },
  {
    id: 2,
    title: "Technology-Driven Growth and Efficiency",
    text:
      "ZICO believes technology can enhance operational efficiency, They adopted Valuefy's Wealth in a Box Technology in 2021 to enhance and fortify their growth trajectory",
    name: "Simon Lim",
    role: "CEO - Zico Asset Management",
  },
  {
    id: 3,
    title: "Bringing Cutting-Edge Analytics to the Next Generation",
    text: "The ability to work with a company like Valuefy enables us to bring cutting edge analytics and digital solutions to our clients which was not something that they would have seen or their previous generations would have actually noted.",
    name: "Soumya Rajan",
    role: "Founder, Managing Director & CEO - Waterfield Advisors",
  },
  {
    id: 4,
    title: "Tailored Data Integration Solutions",
    text:
      "We chose Valuefy as someone who will take care of our data integration, as someone who will create solution which is customized for us and third party solution we can use to empower our portfolio managers.",
    name: "Nilesh Shah",
    role: "Managing Director, Kotak AMC Ltd.",
  },
  {
    id: 5,
    title: "Simplifying Wealth, Empowering Action",
    text:
      "Valuefy has transformed how we manage ultra-high-net-worth families across geographies and generations. Its intuitive platform, automation, and reporting tools save us countless hours and help us operate with agility and confidence. More than just a CRM, ValueFy is a strategic partner that truly understands the nuances of wealth management.",
    name: "Judy Lim",
    role: "Director – COO Office, Farro Capital (Multi-Family Office)",
  },
  {
    id: 6,
    title: "Simplifying Wealth, Amplifying Insight",
    text:
      "As a family office, adopting a unified platform for portfolio aggregation, reporting, and investment tracking has greatly enhanced our operational efficiency and visibility. Valuefy's intuitive and flexible wealth platform aligns seamlessly with the evolving needs of our clients. We're also grateful to MAS for supporting our digital transformation journey.",
    name: "Hooi Hien Koh",
    role: "Head of Wealth Management, (ArchCap - Multi Family Office",
  },
  {
    id: 7,
    title: "Seamless Aggregation, Smarter Decisions",
    text:
      "Valuefy has streamlined our data aggregation and portfolio consolidation by connecting directly with custodian banks, reducing manual work and improving accuracy. While the setup had a learning curve, the team was highly responsive throughout. Its powerful analytics have elevated client service and boosted operational efficiency.",
    name: "Saurav Sen",
    role: "Head Of Operations - InCred Global Wealth"
  },
  {
    id: 8,
    title: "SIMPLIFYING WEALTH, EMPOWERING ACTION",
    text:
      "Partnering with Valuefy through the MAS Pilot Project was a pivotal early step for Cerebrium Capital. Together, we built a tailored platform aligned with our clients’ needs, seamlessly integrating third-party analytics to enhance our advisory capabilities. We appreciate Valuefy’s collaborative approach and thank MAS for driving digital transformation through this initiative.",
    name: "Aman Dhingra",
    role: "Managing Partner - Cerebrium Capital"
  },
  {
    id: 9,
    title: "STREAMLINING FUND MANAGEMENT DIGITALLY",
    text:
      "Valuefy has played a key role in helping us digitize and streamline our fund management operations. The platform has brought better efficiency and scalability to our business processes. We're grateful to MAS for supporting this digital transformation journey.",
    name: "Terence Wong",
    role: "CEO - Azure Capital"
  }
];

const TestimonialCarousel: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const carouselRef = useRef<HTMLDivElement>(null);

  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.5, // Trigger when 50% of the component is visible
      }
    );

    if (carouselRef.current) {
      observer.observe(carouselRef.current);
    }

    return () => {
      if (carouselRef.current) {
        observer.unobserve(carouselRef.current);
      }
    };
  }, []);

  // For mobile swipe functionality
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      handleNext();
    } else if (isRightSwipe) {
      handlePrev();
    }

    setTouchEnd(null);
    setTouchStart(null);
  };

  // Auto rotation for the carousel - now controlled by visibility
  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isVisible) {
      interval = setInterval(() => {
        handleNext();
      }, 5000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [activeIndex, isVisible]);

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div ref={carouselRef} className="bg-black text-white min-h-screen flex flex-col items-center justify-center p-4 sm:p-6 md:p-8">
      <div className="max-w-6xl w-full mt-2 md:mt-12 mb-4">
        {/* Updated heading with Figma specifications */}
        <h1 className="text-center sm:text-left font-sans text-[40px] font-semibold leading-[48px] mb-8 md:mb-16">
          What the{" "}
          <span className="bg-gradient-to-r from-[#E0C3FC] to-[#8EC5FC] bg-clip-text text-transparent">
            Biggest
          </span>
          <span className="sm:hidden"><br /></span>
          <span className="hidden sm:inline"> </span>
          <span className="bg-gradient-to-r from-[#E0C3FC] to-[#8EC5FC] bg-clip-text text-transparent">
            Wealth Managers
          </span>
          <br />
          say about Valuefy
        </h1>
        {/* Mobile Card Carousel */}
        <div className="sm:hidden w-full flex flex-col items-center mt-auto">
          {/* Arrows above the card, right-aligned */}
          <div className="w-full max-w-md mx-auto flex justify-end mb-2 pr-2">
            <div className="flex space-x-3">
              <button
                onClick={handlePrev}
                className="w-12 h-8 flex items-center justify-center rounded-full transition"
                aria-label="Previous testimonial"
              >
                {/* Left Arrow SVG */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 19L5 12M5 12L12 5M5 12H19" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button
                onClick={handleNext}
                className="w-8 h-8 flex items-center justify-center rounded-full transition"
                aria-label="Next testimonial"
              >
                {/* Right Arrow SVG */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
          <div className="relative w-full max-w-md mx-auto bg-slate-100 rounded-2xl p-6 pt-10 text-slate-900 shadow-lg flex flex-col">
            {/* Testimonial Content */}
            <div className="flex flex-col">
              <div className="font-bold text-2xl mb-4 leading-tight">{testimonials[activeIndex].title}</div>
              <div className="mb-6 text-base leading-relaxed">{testimonials[activeIndex].text}</div>
              <div className="font-bold text-lg mb-1">{testimonials[activeIndex].name}</div>
              <div className="text-slate-500 text-base">{testimonials[activeIndex].role}</div>
            </div>
          </div>
        </div>
        {/* Desktop Image Carousel */}
        <div className="hidden sm:block">
          <div className="relative w-full">
            <div
              className="overflow-hidden px-2 sm:px-4 md:px-6"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              >
                {testimonialImages.map((image) => (
                  <div
                    key={image.id}
                    className="w-full flex-shrink-0 px-2 sm:px-4"
                  >
                    <div className="relative aspect-[16/9] sm:aspect-[16/10] md:aspect-[16/9] overflow-hidden rounded-lg">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/api/placeholder/800/400";
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Navigation dots and arrows as before */}
            <div className="flex justify-center mt-6 sm:mt-8 md:mt-12 space-x-3">
              {testimonialImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                    activeIndex === index ? "bg-white scale-125" : "bg-gray-600"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
            <div className="flex justify-between w-full absolute top-1/2 left-0 transform -translate-y-1/2 px-2 sm:px-6 md:px-8">
              <button
                onClick={handlePrev}
                className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 bg-opacity-50 rounded-full flex items-center justify-center border border-gray-700 hover:bg-gray-700 transition-all focus:outline-none focus:ring-2 focus:ring-white"
                aria-label="Previous testimonial"
              >
                <span className="text-lg sm:text-xl">&lt;</span>
              </button>
              <button
                onClick={handleNext}
                className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 bg-opacity-50 rounded-full flex items-center justify-center border border-gray-700 hover:bg-gray-700 transition-all focus:outline-none focus:ring-2 focus:ring-white"
                aria-label="Next testimonial"
              >
                <span className="text-lg sm:text-xl">&gt;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
